var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"getback-contain"},[_c('van-cell',{staticClass:"getback-contain",scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"custom-title",on:{"click":_vm.getBackPage}},[_c('van-icon',{attrs:{"name":"arrow-left","size":"20","color":"#fff"}})],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }